import { CHCValueProps } from "./value-props.component.js";
customElements.define("chc-value-props", CHCValueProps);
export {
  CHCValueProps
};
//# sourceMappingURL=value-props.js.map
